import React from 'react'
import PropTypes from 'prop-types'

import SpookySkeleton from '../SpookySkeleton'
import SkeletonText from '../SkeletonText'

import styles from './styles'

const SkeletonItemCount = ({ className }) => (
  <SpookySkeleton className={className} ariaLabel="SkeletonItemCount" role="presentation">
    <SkeletonText className={styles.text} size="extraSmall" width={100} />
  </SpookySkeleton>
)

SkeletonItemCount.propTypes = {
  className: PropTypes.string,
}

export default SkeletonItemCount
